var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'pt-3 break-word-anywhere',
    _setup.isStream ? 'px-4' : 'px-3',
    _setup.isDisplayModeExpandedOrSlideshow
      ? {
          'pb-4 text-heading-2 text-center font-semibold': true,
          'text-dark-text-100': _setup.darkMode === false,
          'text-light-text-100': _setup.darkMode === true,
          'text-dark-text-100 dark:text-light-text-100': _setup.darkMode === 'auto',
        }
      : {
          'pb-2': true,
          'max-w-[calc(100%-28px)]': !_setup.xOverlay, // 28px is width of more button with slope
          'text-body': _setup.isStream,
          'text-body-small': !_setup.isStream,
          'text-dark-text-200': _setup.darkMode === false,
          'text-light-text-200': _setup.darkMode === true,
          'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
        },
  ],attrs:{"data-testid":"surfacePostPollQuestion"},on:{"dblclick":function($event){return _vm.$emit('dblclick', $event)}}},[_vm._v("\n  "+_vm._s(_setup.question)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }